import { Vec2 } from "miglib";

export function positionsInRadius(x0: number, y0: number, radius: number): Vec2[] {
    const positions: Vec2[] = [];
    const r = Math.ceil(radius);

    for (let dx = -r; dx <= r; dx++) {
        for (let dy = -r; dy <= r; dy++) {
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist <= radius) {
                positions.push({ x: x0 + dx, y: y0 + dy });
            }
        }
    }

    return positions;
}

export function randomPositionInRadius(x0: number, y0: number, radius: number, towards?: Vec2): Vec2 {
    const r = radius * Math.sqrt(Math.random());

    const baseAngle = towards ? Math.atan2(towards.y - y0, towards.x - x0) : Math.random() * 2 * Math.PI;
    const spread = towards ? Math.PI / 2 : 2 * Math.PI;
    const theta = baseAngle + (Math.random() - 0.5) * spread;

    return {
        x: Math.round(x0 + r * Math.cos(theta)),
        y: Math.round(y0 + r * Math.sin(theta)),
    };
}
